import { styled } from "@mui/material";

export const ListWrap = styled("div")(() => ({
  backgroundColor: "var(--color-background-primary)",
}));